type CursorTextIconProps = { className?: string; title?: string; transform?: string }

const CursorTextIcon = ({ className, title }: CursorTextIconProps) => (
  <svg width={16} height={24} className={className} viewBox="0 0 16 15">
    <title>{title}</title>
    <g id="R3--simplified" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Content-Builder-1" transform="translate(-88.000000, -2611.000000)">
        <g id="Summary-Section-Copy" transform="translate(16.000000, 1353.000000)">
          <g id="Text-Input" transform="translate(0.000000, 507.000000)">
            <g id="Text-Input-Header" transform="translate(12.000000, 8.000000)">
              <g id="Data-submit" transform="translate(0.000000, 644.000000)">
                <g id="Group-13" transform="translate(12.000000, 56.000000)">
                  <g id="Group-2" transform="translate(0.000000, 27.000000)">
                    <g id="cursor-text" transform="translate(48.000000, 16.500000)">
                      <rect id="Rectangle" stroke="#1B1B1B" strokeWidth="2" x="1" y="1" width="14" height="12" rx="2" />
                      <path
                        d="M5.72727273,5 C5.72727273,4.4485 6.135,4 6.63636364,4 L7.09090909,4 L7.09090909,3 L6.63636364,3 C6.09090909,3 5.60636364,3.271 5.27272727,3.691 C4.93909091,3.271 4.45454545,3 3.90909091,3 L3.45454545,3 L3.45454545,4 L3.90909091,4 C4.41045455,4 4.81818182,4.4485 4.81818182,5 L4.81818182,5.5 L4.81818182,7.5 L3.45454545,7.5 L3.45454545,8.5 L4.81818182,8.5 L4.81818182,9 C4.81818182,9.5515 4.41045455,10 3.90909091,10 L3.45454545,10 L3.45454545,11 L3.90909091,11 C4.45454545,11 4.93909091,10.729 5.27272727,10.309 C5.60636364,10.729 6.09090909,11 6.63636364,11 L7.09090909,11 L7.09090909,10 L6.63636364,10 C6.135,10 5.72727273,9.5515 5.72727273,9 L5.72727273,8.5 L7.09090909,8.5 L7.09090909,7.5 L5.72727273,7.5 L5.72727273,5.5 L5.72727273,5 Z"
                        id="Path"
                        fill="#1B1B1B"
                        fillRule="nonzero"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

CursorTextIcon.defaultProps = {
  className: '',
  title: 'cursor-text'
}

export default CursorTextIcon
